export default "__VITE_ASSET__Du2cBfZc__"